import { FetchStatus } from '@powdr/constants';

import { ALERTS_PENDING, ALERTS_SUCCESS, ALERTS_ERROR } from '../types';

const initialState = {
  data: [],
  status: FetchStatus.IDLE,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ALERTS_PENDING:
      return {
        ...state,
        status: FetchStatus.LOADING,
      };
    case ALERTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: FetchStatus.SUCCESS,
      };
    case ALERTS_ERROR:
      return {
        status: FetchStatus.ERROR,
        error: action.payload,
      };
    default: return state;
  }
};
